import axios from "axios";
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useParams, useRouteMatch } from "react-router";
import { MaintenanceServiceBox } from "../components/maintenance";
import MaintenanceContext from "../maintenanceContext";
import ServiceFeatureList from "../components/serviceFeature";
import Breadcrumb from "../../../components/__simple/breadcrumb";
import ServiceHeaderBanner from "../components/serviceHeaderBanner";
import config from "../../../configuration/config";
import { WhyHJSection } from "../../../sections/whyHJSection";
const SubMainServicePage = () => {
    const { t: trans, i18n } = useTranslation(["info", "common"]);
    const { handleServiceOrder } = useContext(MaintenanceContext);
    const { path } = useRouteMatch()
    const languageDir = 'language-' + (i18n.language || 'ar');
    let { ID } = useParams();
    const [SubService, setSubService] = useState([]);
    function fetchSubService(IDMain) {
        const Body = {
            "MainID": IDMain
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchMntc_SubService1`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                setTimeout(setSubService(response.data), 1000);

            })
            .catch(function (error) {
                console.log(error);
            });



    }

    const [MainInfo, setMainInfo] = useState([]);
    function fetchMainInfo(IDMain) {
        const Body = {
            "Main": IDMain
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchMainService_Info`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                setTimeout(setMainInfo(response.data), 1000);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [Special, setSpecial] = useState([]);
    function fetchFetchMaintenanceSpecial() {
        const Body = {}

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_FetchMaintenanceSpecial`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                setTimeout(setSpecial(response.data), 1000);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const lang = localStorage.getItem('i18nextLng');
    useEffect(() => {
        fetchSubService(ID); fetchFetchMaintenanceSpecial();
        setTimeout(() => { fetchMainInfo(ID) }, 100);
    }, [ID]);
    return (
        <>
            {

                MainInfo.map((p) => {

                    return (<ServiceHeaderBanner
                        bannerDescriptor={{ image: p?.banner, subTitle: '', title: lang === "en" ? p.DescriptionEn : p.DescriptionAr }}
                        hasRedirect={false}
                    />)
                })
            }

            <div className="container">
                <Breadcrumb className={"mt-16 "}
                    links={[
                        {
                            name: trans("info:maintenance"),
                            to: '/maintenance'
                        },
                        {
                            name: trans("info:main_sub_main_service"),
                            to: `${path}`
                        }
                    ]}
                />
            </div>
            <div className={"w-full mb-32 " + languageDir}>
                <div className="mainteance-services-wrapper">
                    <div className="section-heading-container">
                        <h2 className="section-heading">{trans("info:main_sub_main_service")}</h2>
                    </div>
                    <div className="mainteance-scroll-container">
                        <div className="mainteance-horizontal-list">
                            {
                                SubService.map((item, index) => {
                                    return (
                                        <div key={index} className="flex-shrink-0">
                                            <MaintenanceServiceBox
                                                image={item.img ? `url('${(config.mainURL + item.img.replaceAll("\\", "/"))}')` : `url('/assets/images/defult.png')`}
                                                to={"#"}
                                                title={lang === 'ar' ? item.DescriptionAr : item.DescriptionEn}
                                                onServiceOrder={() => {
                                                    handleServiceOrder({
                                                        showPopup: true,
                                                        type: item.Level,
                                                        main: item.MainServiceID,
                                                        sub1: item.SubService1ID,
                                                        sub2: item.SubService2ID
                                                    });
                                                }}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>

                {
                    Special && Special.length > 0 &&
                    <ServiceFeatureList
                        title={trans("info:main_feature")}
                        values={Special.map((Sp) => { return { title: lang === "ar" ? Sp.titleAr : Sp.titleEn, image: "data:image/png;base64," + Sp.icon } })}
                    />

                }


            </div>
            <WhyHJSection />
        </>
    );
}
export default SubMainServicePage;